import {Component, Injector} from '@angular/core';
import {EntitiesListOrchestratorComponent} from "../entities-list-orchestrator/entities-list-orchestrator.component";
import {ObjectsService} from "../../../../../services/objects.service";

@Component({
    selector: 'app-objects-list-orchestrator',
    templateUrl: '../entities-list-orchestrator/entities-list-orchestrator.component.html',
    styleUrls: ['../entities-list-orchestrator/entities-list-orchestrator.component.css'],
    standalone: false
})
export class ObjectsListOrchestratorComponent extends EntitiesListOrchestratorComponent {

  public constructor(protected injector: Injector) {
    super(injector);
    this.manipulationService = injector.get(ObjectsService);
  }
}
